if (!customElements.get('sticky-product')) {
  class StickyProduct extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        addToCartBtn: '[add-to-cart]',
        container: '.st-prod',
        addToCartMain: `#ProductSubmitButton-${this.dataset.id}`,
        triggerElement: '.buy-buttons__block'
      };
      this.isButtonVisible = true;
      this.init();
    }

    init() {
      this.addToCartBtn = this.querySelector(this.selectors.addToCartBtn);
      this.addToCartMain = document.querySelector(this.selectors.addToCartMain) || document.querySelector('[name="add"]');
      this.container = this.querySelector(this.selectors.container);
      this.triggerElement = document.querySelector(`#ProductInfo-${this.dataset.id}`)?.querySelector(this.selectors.triggerElement);
      this.addToCartBtn?.addEventListener('click', () => {
        this.scrollToBtn();
      });
      window.addEventListener('scroll', () => {
        this.checkButtonVisibility();
      });
      document.addEventListener('DOMContentLoaded', this.checkButtonVisibility.bind(this));
    }

    checkButtonVisibility() {
      if (!this.triggerElement) {
        this.triggerElement = document.querySelector(`#ProductInfo-${this.dataset.id}`)?.querySelector(this.selectors.triggerElement);
      }
      if (!this.triggerElement) return;

      const triggerRect = this.triggerElement.getBoundingClientRect();
      // console.log(triggerRect);

      if (triggerRect.bottom <= 0) {
        if (this.isButtonVisible) {
          this.isButtonVisible = false;
          this.showStickyProduct();
        }
      } else {
        if (!this.isButtonVisible) {
          this.isButtonVisible = true;
          this.hideStickyProduct();
        }
      }
    }

    showStickyProduct() {
      if (this.container && !this.container.classList.contains('active')) {
        this.container.classList.add('active');
      }
    }

    hideStickyProduct() {
      if (this.container && this.container.classList.contains('active')) {
        this.container.classList.remove('active');
      }
    }
    scrollToBtn() {
      this.addToCartMain = document.querySelector(this.selectors.addToCartMain) || document.querySelector('[name="add"]');

      if (!this.triggerElement) {
        this.triggerElement = document.querySelector(`#ProductInfo-${this.dataset.id}`)?.querySelector(this.selectors.triggerElement);
      }

      if (this.addToCartMain && this.triggerElement) {
        this.triggerElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        if (!this.addToCartMain.disabled) {
          this.addToCartMain.click();
        }
      }
    }
  }
  customElements.define('sticky-product', StickyProduct);
}